import React from 'react';

import ButtonTabs from '../../../../components/tabs/ButtonTabs';

function renderButtonTabsBlock(data, index, renderStaticSection) {
  const {
          CONTENT,
          LABEL,
          NAV,
          STYLE,
          TITLE: title,
          TABS_LEVEL = 1,
        } = data;

  return (
    <section key={index} className={'withTabs'}>
      {typeof title === 'string' && title.length > 0 && (
        <h2>{title}</h2>
      )}
      <ButtonTabs
        content={CONTENT}
        label={LABEL}
        nav={NAV}
        renderStaticSection={renderStaticSection}
        style={STYLE}
        tabsRouterLevel={TABS_LEVEL}
      />
    </section>
  );
}

export default renderButtonTabsBlock;